import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/incident-management",
    name: "Incident Manager",
    component: () => import("./incidentManager.vue"),
  },
] satisfies RouteRecordRaw[];
